
import { Component, Vue } from 'vue-property-decorator'
import { popUpRoute } from '@/services/utils/popupRoute'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import { cashOutOrderEndpoint } from '@/modules/order-management/cashout-order'
import eventBus from '@/eventBus'

@Component({
  name: 'CancelCashoutOrder',
  components: {
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class CancelCashoutOrder extends Vue {
  isBtnLoading = false

  /** submit the data to the desired endpoint. */
  async handleSubmit() {
    const { id } = parsePathQueryString(location.search)
    this.isBtnLoading = true
    if (id)
      await cashOutOrderEndpoint
        .cancelOrder(id)
        .then(() => {
          this.isBtnLoading = false
          this.closePopUp()
        })
        .finally(() => {
          eventBus.refreshData()
          this.isBtnLoading = false
        })
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }
}
